"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RFQGrid = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var collectionsRef_1 = require("common/db/collectionsRef");
var budgetLinesList_1 = require("common/global/budgetLinesList");
var currenciesList_1 = require("common/global/currenciesList");
var donorsList_1 = require("common/global/donorsList");
var projectsList_1 = require("common/global/projectsList");
var unitsList_1 = require("common/global/unitsList");
var useCurrenciesOptions_1 = __importDefault(require("common/hooks/useCurrenciesOptions"));
var lodash_1 = require("lodash");
var getDateForCell_1 = __importDefault(require("portal/utils/getDateForCell"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Grid_1 = require("../../../components/Grid/Grid");
var emptyCell_1 = require("../../../components/Grid/helpers/emptyCell");
var titleCell_1 = require("../../../components/Grid/helpers/titleCell");
var valueByMode_1 = require("../../../components/Grid/helpers/valueByMode");
var header_1 = require("../../../components/header");
var OrderHeader_1 = __importDefault(require("../components/OrderHeader"));
var IRGrid_1 = require("../IR/IRGrid");
function RFQGrid(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var state = _a.state, mode = _a.mode, dispatch = _a.dispatch;
    var t = (0, react_i18next_1.useTranslation)().t;
    var currencySelectData = (0, useCurrenciesOptions_1.default)();
    var projectsCodes = state.projectsIds
        .map(function (projectId) { return projectsList_1.globalProjectsData[projectId !== null && projectId !== void 0 ? projectId : ""].code; })
        .join(", ");
    //   const budgetLineId = state.budgetLineId;
    //   const budgetLineCode = globalBudgetLinesData[budgetLineId]?.code;
    //   const budgetLinesIds = state.budgetLinesIds;
    var items = function () { return function (it) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var productUnit = (_a = state.RFQItems[it.index]) === null || _a === void 0 ? void 0 : _a.unitId;
        // const budgetLineId = it.budgetLineId ?? state.budgetLineId;
        var budgetLinesIds = it.budgetLinesIds;
        return [
            (0, valueByMode_1.ValueByMode)({
                mode: "view",
                value: it.index + 1 + "",
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: "view",
                // value: globalBudgetLinesData[budgetLineId].code ?? "",
                value: budgetLinesIds
                    .map(function (budgetLineId) { return budgetLinesList_1.globalBudgetLinesData[budgetLineId !== null && budgetLineId !== void 0 ? budgetLineId : ""].code; })
                    .join(", "),
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: "view",
                value: (_b = "".concat(it.productName, " / ").concat(it.itemDescription)) !== null && _b !== void 0 ? _b : "",
                colSpan: 2,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_c = it.offeredItem) !== null && _c !== void 0 ? _c : "",
                colSpan: 1,
                inputType: "textInput",
                path: "RFQItems[".concat(it.index, "].offeredItem"),
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_d = it.originCountry) !== null && _d !== void 0 ? _d : "",
                colSpan: 1,
                inputType: "textInput",
                path: "RFQItems[".concat(it.index, "].originCountry"),
                // required: false,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_e = it.warranty) !== null && _e !== void 0 ? _e : "",
                colSpan: 1,
                inputType: "textInput",
                path: "RFQItems[".concat(it.index, "].warranty"),
                // required: false,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_f = it.expiryDate) !== null && _f !== void 0 ? _f : "",
                colSpan: 1,
                inputType: "textInput",
                path: "RFQItems[".concat(it.index, "].expiryDate"),
                // required: false,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: "view",
                value: (_h = (_g = unitsList_1.globalUnitsData[productUnit !== null && productUnit !== void 0 ? productUnit : ""]) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : "",
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: "view",
                value: (_j = it.quantity) !== null && _j !== void 0 ? _j : 0,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_k = it.unitPrice) !== null && _k !== void 0 ? _k : 0,
                colSpan: 1,
                inputType: "numberInput",
                path: "RFQItems[".concat(it.index, "].unitPrice"),
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: it.unitPrice * it.quantity === 0
                    ? ""
                    : (_l = (it.unitPrice * it.quantity)) === null || _l === void 0 ? void 0 : _l.toFixed(2),
                colSpan: 1,
                inputType: "text",
                path: "RFQItems[".concat(it.index, "].total"),
            }),
        ];
    }; };
    var getCellsForIrItem = items();
    var RFQItems = (0, lodash_1.map)(state.RFQItems, getCellsForIrItem);
    var itemsTotal = state.RFQItems.map(function (item) {
        return item.unitPrice == 0 ? 0 : item.unitPrice * item.quantity;
    });
    var totalBeforeKDV = (0, lodash_1.sum)(itemsTotal);
    var overallTotal = (0, lodash_1.sum)([
        totalBeforeKDV,
        state.shippingCosts !== "included" && state.shippingCosts !== ""
            ? state.shippingCosts
            : 0,
        state.taxes !== "included" && state.taxes !== "" ? state.taxes : 0,
    ]);
    (0, react_1.useEffect)(function () {
        dispatch({ type: "setOverallTotal", data: { overallTotal: overallTotal } });
    }, [dispatch, overallTotal]);
    var RFQHeader = [
        [
            (0, titleCell_1.TitleCell)({ title: t("rfq.rfqDate") }),
            (_b = (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: mode === "view"
                    ? t("common.date", { date: (0, getDateForCell_1.default)(state === null || state === void 0 ? void 0 : state.RFQDate, mode) })
                    : (0, getDateForCell_1.default)(state === null || state === void 0 ? void 0 : state.RFQDate, mode),
                inputType: "datePicker",
                path: "RFQDate",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
                colSpan: 3,
            })) !== null && _b !== void 0 ? _b : null,
            (0, titleCell_1.TitleCell)({ title: t("rfq.rfqNo") }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.RFQNo,
                inputType: "text",
                path: "RFQNo",
                colSpan: 3,
            }),
            (0, titleCell_1.TitleCell)({ title: t("rfq.projectCode") }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: projectsCodes !== null && projectsCodes !== void 0 ? projectsCodes : "",
                inputType: "text",
                path: "code",
                colSpan: 3,
            }),
            // TitleCell({ title: t('rfq.budgetLine') }),
            // ValueByMode({
            //     mode,
            //     value: budgetLineCode ?? '',
            //     inputType: 'text',
            //     path: 'budgetLineId',
            //     colSpan: 2,
            // }),
        ],
    ];
    var rfqBody = [
        (0, titleCell_1.TitleCell)({ title: t("rfq.itemNo"), colSpan: 1, rowSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t("rfq.budgetLine"), colSpan: 1, rowSpan: 2 }),
        (0, titleCell_1.TitleCell)({
            title: t("rfq.requestedItemDescription"),
            colSpan: 2,
            rowSpan: 2,
        }),
        (0, titleCell_1.TitleCell)({ title: t("rfq.offeredItem"), colSpan: 4 }),
        (0, titleCell_1.TitleCell)({ title: t("rfq.unit"), colSpan: 1, rowSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t("rfq.quantity"), colSpan: 1, rowSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t("rfq.unitPrice"), colSpan: 1, rowSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t("rfq.total"), colSpan: 1, rowSpan: 2 }),
    ];
    var rfqSummary = [
        [
            // emptyCell({ colSpan: 9, rowSpan: 5}),
            (0, titleCell_1.TitleCell)({
                title: "IMPORTANT: All actual and potential conflicts of interests must be disclosed to Independent Doctors Association directly to the employee’s supervisor or to Human Resources whenever a conflict arises. By signing this document Independent Doctors Association staff attests:- they or their immediate family members have no personal relationship with listed vendors or their employees, - no interest or financial gain or any other type of Conflict of Interest related to this procurement- to have not been employed by any of the vendors from solicitation previously.",
                colSpan: 9,
                rowSpan: 5,
                backgroundColor: "#fff",
            }),
            (0, titleCell_1.TitleCell)({ title: t("rfq.total"), colSpan: 2, backgroundColor: "#fff" }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: totalBeforeKDV === 0 ? "" : totalBeforeKDV === null || totalBeforeKDV === void 0 ? void 0 : totalBeforeKDV.toFixed(2),
                colSpan: 1,
                inputType: "text",
                path: "total",
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({
                title: t("rfq.taxesKdv"),
                colSpan: 2,
                backgroundColor: "#fff",
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.taxes !== 0 ? state.taxes : 0,
                colSpan: 1,
                inputType: "numberInput",
                path: "taxes",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({
                title: t("rfq.shippingCostInsurance"),
                colSpan: 2,
                backgroundColor: "#fff",
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.shippingCosts !== 0 ? state.shippingCosts : 0,
                colSpan: 1,
                inputType: "numberInput",
                path: "shippingCosts",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({
                title: t("rfq.currency"),
                colSpan: 2,
                backgroundColor: "#fff",
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_d = (_c = currenciesList_1.globalCurrenciesData[state.currencyId]) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : "",
                colSpan: 1,
                inputType: "select",
                path: "currencyId",
                selectData: currencySelectData,
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({
                title: t("rfq.overallTotal"),
                colSpan: 2,
                backgroundColor: "#fff",
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: overallTotal ? overallTotal === null || overallTotal === void 0 ? void 0 : overallTotal.toFixed(2) : null,
                colSpan: 1,
                inputType: "textInput",
                path: "overallTotal",
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("rfq.otherInformation"), colSpan: 4 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_e = state.otherInformation) !== null && _e !== void 0 ? _e : "",
                colSpan: 8,
                inputType: "textInput",
                path: "otherInformation",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
    ];
    var signatures = [
        [
            (0, titleCell_1.TitleCell)({
                title: t("rfq.processedByIda"),
                colSpan: 6,
                textAlign: "center",
            }),
            (0, titleCell_1.TitleCell)({
                title: t("rfq.processedBySupplier"),
                colSpan: 6,
                textAlign: "center",
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("rfq.name"), colSpan: 1, backgroundColor: "#fff" }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_f = state.idaApprovalUser) !== null && _f !== void 0 ? _f : "",
                colSpan: 5,
                inputType: "textArea",
                path: "idaApprovalUser",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: t("rfq.name"), colSpan: 1, backgroundColor: "#fff" }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_g = state.supplierApprovalUser) !== null && _g !== void 0 ? _g : "",
                colSpan: 5,
                inputType: "textArea",
                path: "supplierApprovalUser",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("rfq.date"), colSpan: 1, backgroundColor: "#fff" }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: mode === "view"
                    ? t("common.date", {
                        date: (0, getDateForCell_1.default)(state.idaApprovalDate, mode),
                    })
                    : (0, getDateForCell_1.default)(state.idaApprovalDate, mode),
                colSpan: 5,
                inputType: "datePicker",
                path: "idaApprovalDate",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: t("rfq.date"), colSpan: 1, backgroundColor: "#fff" }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: mode === "view"
                    ? t("common.date", {
                        date: (0, getDateForCell_1.default)(state.supplierApprovalDate, mode),
                    })
                    : (0, getDateForCell_1.default)(state.supplierApprovalDate, mode),
                colSpan: 5,
                inputType: "datePicker",
                path: "supplierApprovalDate",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({
                title: t("rfq.signature"),
                colSpan: 1,
                backgroundColor: "#fff",
            }),
            (0, emptyCell_1.emptyCell)({ colSpan: 5 }),
            (0, titleCell_1.TitleCell)({
                title: t("rfq.signature"),
                colSpan: 1,
                backgroundColor: "#fff",
            }),
            (0, emptyCell_1.emptyCell)({ colSpan: 5 }),
        ],
    ];
    var suppliersFooter = [
        [
            (0, titleCell_1.TitleCell)({
                title: t("rfq.deliveryPlaceAndModeOfTransport"),
                colSpan: 6,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_h = state.deliveryPlace) !== null && _h !== void 0 ? _h : "",
                colSpan: 6,
                inputType: "textInput",
                path: "deliveryPlace",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({
                title: t("rfq.deliveryDatePleaseSpecifyDatesIfPartialDelivery"),
                colSpan: 6,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.deliveryDate,
                colSpan: 6,
                inputType: "textInput",
                path: "deliveryDate",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: "Payment Preferences", colSpan: 6 }),
            (0, titleCell_1.TitleCell)({ title: "by bank", colSpan: 1 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.byBank,
                colSpan: 2,
                inputType: "select",
                selectData: [
                    { text: "Yes", value: "yes" },
                    { text: "No", value: "no" },
                ],
                path: "byBank",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: "by cash", colSpan: 1 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.byCash,
                colSpan: 2,
                inputType: "select",
                selectData: [
                    { text: "Yes", value: "yes" },
                    { text: "No", value: "no" },
                ],
                path: "byCash",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: "Payment Terms", colSpan: 6 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_j = state.deliveryTerms) !== null && _j !== void 0 ? _j : "",
                colSpan: 6,
                inputType: "textInput",
                path: "deliveryTerms",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("rfq.quotationValidity"), colSpan: 6 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.quotationValidity,
                colSpan: 6,
                inputType: "textInput",
                path: "quotationValidity",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
    ];
    var donorId = (_k = projectsList_1.globalProjectsData[state.projectId]) === null || _k === void 0 ? void 0 : _k.donorId;
    var miLogo = __assign(__assign({}, header_1.baseCell), { type: "image", src: (_l = donorsList_1.globalDonorsData[donorId]) === null || _l === void 0 ? void 0 : _l.logo, height: 50, colSpan: 4, textAlign: "center" });
    var gridData = {
        data: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
            (0, IRGrid_1.logoHeader)({
                projectId: state.irData.projectId,
                idaLogo: miLogo,
                title: t("rfq.requestForQuotationsRfq"),
                colSpan: 4,
            })
        ], RFQHeader, true), suppliersSection(state, mode, t), true), suppliersFooter, true), [
            rfqBody,
            [
                (0, titleCell_1.TitleCell)({ title: t("rfq.brand"), colSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t("rfq.originCountry"), colSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t("rfq.warranty"), colSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t("rfq.expiryDate"), colSpan: 1 }),
            ]
        ], false), RFQItems, true), rfqSummary, true), signatures, true),
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(OrderHeader_1.default, { state: state, dispatch: dispatch, type: "RFQ", orderRef: collectionsRef_1.RFQsRef.doc(state.RFQId) }), (0, jsx_runtime_1.jsx)("div", __assign({ style: { backgroundColor: "#fff" } }, { children: (0, jsx_runtime_1.jsx)(Grid_1.ExcelLikeGrid, { onButtonClicked: function (action, payload) {
                        dispatch({
                            type: "buttonClick",
                            data: {
                                action: action,
                                payload: payload,
                            },
                        });
                    }, onValueUpdate: function (path, newValue) {
                        dispatch({
                            type: "update",
                            payload: {
                                path: path,
                                newValue: newValue,
                            },
                        });
                    }, grid: gridData }) }))] }));
}
exports.RFQGrid = RFQGrid;
function suppliersSection(state, mode, t) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return [
        [
            (0, titleCell_1.TitleCell)({ title: t("rfq.form"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "Indepent Doctor Association",
                inputType: "text",
                path: "supplier",
                colSpan: 4,
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: t("rfq.companyName"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: mode === "view" ? state.supplierName : state.supplierId,
                inputType: "supplierSelect",
                path: "supplier",
                colSpan: 4,
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("rfq.address"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "Binevler Mah. 81053 Nolu Sok. No:34 Şahinbey Gaziantep/Turkey",
                inputType: "text",
                path: "supplier",
                colSpan: 4,
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            // ValueByMode({
            //     mode,
            //     value: state.formDescription,
            //     rowSpan: 4,
            //     colSpan: 6,
            //     inputType: 'textArea',
            //     path: 'formDescription',
            //     triedSubmitting: state.triedSubmitting,
            //     required: state.triedSubmitting,
            // }),
            (0, titleCell_1.TitleCell)({ title: t("rfq.companyAddress"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: mode === "view"
                    ? state.supplierAddress
                    : (_b = (_a = state.supplier) === null || _a === void 0 ? void 0 : _a.physicalAddress) !== null && _b !== void 0 ? _b : "",
                colSpan: 4,
                inputType: "text",
                path: "supplier.physicalAddress",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("rfq.representative"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "Elif Şahin",
                colSpan: 4,
                inputType: "text",
                path: "supplier.contactPerson",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: t("rfq.representative"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: mode === "view"
                    ? state.supplierContactName
                    : (_d = (_c = state.supplier) === null || _c === void 0 ? void 0 : _c.contactPerson) !== null && _d !== void 0 ? _d : "",
                colSpan: 4,
                inputType: "text",
                path: "supplier.contactPerson",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("rfq.tel"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "+90 534 078 50 40",
                colSpan: 4,
                inputType: "text",
                path: "supplier.mobilePhone",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: t("rfq.tel"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: mode === "view"
                    ? (_e = state.supplierTel) !== null && _e !== void 0 ? _e : ""
                    : (_g = (_f = state.supplier) === null || _f === void 0 ? void 0 : _f.mobilePhone) !== null && _g !== void 0 ? _g : "",
                colSpan: 4,
                inputType: "text",
                path: "supplier.mobilePhone",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("rfq.website"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "https://ida-org.com/en/",
                colSpan: 4,
                inputType: "text",
                path: "supplier.website",
            }),
            (0, titleCell_1.TitleCell)({ title: t("rfq.website"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: mode === "view"
                    ? state.supplierWebsite
                    : (_j = (_h = state.supplier) === null || _h === void 0 ? void 0 : _h.website) !== null && _j !== void 0 ? _j : "",
                colSpan: 4,
                inputType: "text",
                path: "supplier.website",
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("rfq.email"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "elif.sahin@ida-org.com",
                colSpan: 4,
                inputType: "text",
                path: "supplier.email",
            }),
            (0, titleCell_1.TitleCell)({ title: t("rfq.email"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: mode === "view" ? state.supplierEmail : (_l = (_k = state.supplier) === null || _k === void 0 ? void 0 : _k.email) !== null && _l !== void 0 ? _l : "",
                colSpan: 4,
                inputType: "text",
                path: "supplier.email",
            }),
        ],
        // [
        //     TitleCell({ title: t('rfq.contactPersonMobile'), colSpan: 2 }),
        //     ValueByMode({
        //         mode,
        //         value: mode === 'view' ? state.supplierContactNumber : state.supplier?.companyNumber ?? '',
        //         colSpan: 4,
        //         inputType: 'text',
        //         path: 'supplier.companyNumber',
        //         required: state.triedSubmitting,
        //         triedSubmitting: state.triedSubmitting,
        //     }),
        // ],
    ];
}
